import React, { useContext, useCallback } from 'react';
import { Box, BoxExtendedProps } from 'grommet';

import ScheduleCard from './ScheduleCard';
import { LiveCardProps, ScheduleStatus } from './schedule.d';
import { TeamGameResponse } from '@dto/api';
import { ResponsiveContext } from 'grommet';
import useLiveGameStatus from '@hooks/useLiveGameStatus';
import { TeamContext } from '@services/Session/context';

const LiveCard: React.FC<LiveCardProps> = ({
  teamId,
  gameInfo,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isPlayable,
  gameIsStreaming,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  cameraStatus,
  onClick,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  hlsRef,
  scheduleStatus,
}) => {
  const teamStore = useContext(TeamContext);
  const viewportSize = useContext(ResponsiveContext);
  const handlePropUpdates = useCallback((): BoxExtendedProps => {
    if (viewportSize === 'large' || viewportSize === 'xlarge') {
      return {
        direction: 'column',
        width: '49%',
      };
    }
    return { direction: 'column' };
  }, [viewportSize]);

  const liveScoringStatus = useLiveGameStatus(
    gameInfo?.paths?.live_game,
    gameInfo?.isEnded
  );

  // from state
  const nextStreamableGame = teamStore.nextStreamableGame;
  const gameIsLiveAndScoring =
    (liveScoringStatus &&
      nextStreamableGame?.id === liveScoringStatus.gameStatus?.teamGameId &&
      gameIsStreaming) ||
    false;

  return (
    <>
      <Box
        data-testid="live-card"
        width={viewportSize === 'small' ? '100%' : '49%'}
      >
        <Box {...handlePropUpdates()} width="100%">
          <ScheduleCard
            liveScoringStatus={liveScoringStatus}
            scheduleStatus={
              gameIsLiveAndScoring ? ScheduleStatus.LIVE : scheduleStatus
            }
            gameInfo={gameInfo as TeamGameResponse}
            teamId={teamId}
            onClick={onClick}
            viewportSize="small"
          />
        </Box>
      </Box>
    </>
  );
};

export default LiveCard;
